import QuizType from "./QuizType";

export default QuizType;
